import React from 'react';
import Util from '../Util';
import $ from 'jquery';
import Api from '../Api';

const INVALID_CCLOCAL_ID = -1;
const INVALID_CCLOCAL_ID_PARSED = -2;
let maxStopDays = 0;
let bakTableName = '';

class SheldonLinuxdashCmd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: '',
      path: '',
      content: '',
      transactionData: [],
      cclocalID: INVALID_CCLOCAL_ID,
    };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  // This helper function first checks so see if action is backup or drop,
  // then dislpays pop up confirmation to backup or drop
  checkHelper(action) {
      switch (action) {
        case 'backup':
          if (!window.confirm('Confirm ' + action + ' cclocal table?')) {
            return false;
          }
          return true;

        case 'drop':
          if (!window.confirm('Confirm ' + action + ' cclocal bak table?')) {
          return false;
          }
          return true;

      }
    }

  handleButtonClick(type) {
    let hostInfo = this.props.hostInfo;
    let { ip } = hostInfo;

    if (this.unmounted) return;

    // Check if host is a kiosk with valid IP
    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{ color: 'red' }}>Invalid ip: {ip}</span>,
      });
      return;
    }

    let linuxdash = Util.getLinuxDashPath(hostInfo);
    let payapi = Util.getPayApiPath(hostInfo);
    let method = '';
    let path = '';
    let dataType = 'text';
    let timeout = 90000;
    let wrapView = false;

    switch (type) {
      case 'cclocal/fetchsum':
        method = 'POST';
        path = `${linuxdash}/exec/mysql/kskdb?args=` +
          encodeURIComponent('365linuxdash select sum(amount) from salespayment where type=\'CREDIT\' and (reason like \'% offline%\' or reason like \'Payment%\')');
        break;
      case 'cclocal/fetchtransaction':
        method = 'POST'
        path = `${linuxdash}/exec/mysql/kskdb?args=` +
          encodeURIComponent('365linuxdash SELECT * FROM cclocal;');
        break;
      case 'cclocal/backuptransaction':
        method = 'GET';
        path = `${linuxdash}/server/?module=backup_kskdb_cclocal`;
        dataType = 'text';

        if (!this.checkHelper('backup')) return;
        break;
      case 'cclocal/movetocclocal':
        method = 'POST';
        path = `${linuxdash}/exec/mysql/kskdb?args=` +
          encodeURIComponent(`365linuxdash insert into cclocal (select * from ${bakTableName})`);
        break;
      case 'cclocal/dropbaktable':
        method = 'POST';
        if(!bakTableName.includes('_bak'))
        {
          window.alert('Invalid Table Name entered.');
          return;
        }

        path = `${linuxdash}/exec/mysql/kskdb?args=` +
          encodeURIComponent(`365linuxdash Drop table ${bakTableName}`);

        if (!this.checkHelper('drop')) return;
        break;
      case 'cclocal/updatemaxstopdays':
        if(maxStopDays > 0)
        {
          path = `${payapi}/cmd?cclocalmaxstopdays=${maxStopDays}`;
          break;
        }
        else
        {
          alert("Please use a positive number.");
          return;
        }

      case 'cclocal/uploadlocal':
        path = `${payapi}/cmd?uploadlocal=yes`;
        break;
      case 'cclocal/restmaxstopdaystodefault':
        path = `${payapi}/cmd?cclocalmaxstopdays=14`;
        break;
      case 'cclocal/fetchcclocalbaktablenames':
        method = 'POST'
        path = `${linuxdash}/exec/mysql/kskdb?args=` +
          encodeURIComponent('365linuxdash select table_name from information_schema.tables where table_name like \'cclocal_bak_%\'');
        break;
    }

    // Check to see if another request is already in progress
    if (this.inProgress) {
      this.setState({
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    this.setState({
      type: type,
      path: path,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    return $.ajax({
      url: path,
      dataType: dataType,
      method: method,
      timeout: timeout,
      statusCode: {
        304: function (xhr) {
          console.log("304 status")
        }
      }})
      .always(() => {
        this.inProgress = false;
      })
      .done((data) => {
        this.setState({
          content: wrapView ? <div>{data}</div> : <pre style={{ color: '' }}>{data}</pre>,
          transactionData: data.split('\n'),
        });
      })
      .fail((jqXHR) => {
        this.setState({
          content: <span style={{ color: 'red' }}>{jqXHR.responseText}</span>,
        });
      });
  }

  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0,object.target.maxLength);
    }
  }

  render() {
    let { panelHeight } = this.props;
    let { type } = this.state;

    return (
      <div className='sheldon-content-wrapper'>
        <div style={{ display: 'block', height: '20px' }}></div>
        <h2>linuxdash Commands</h2>
        <div style={{ margin: '20px 0' }}>
          <b>Aged Transaction Process: </b>
          To start the aged transaction process you will want to follow the steps in order 1-3. (Remember to add _bak table name to the ticket) <br />
          Once you have confirmation to process the transactions follow steps 3-8 <br />
          If you are supposed to delete the aged transactions simply use step 3 then 7<br />
          <br />
          <b>NOTE: If the CCLocal aged transactions days diff do not match the offline period, verify the data/time is correct on the kiosk and reach out to Technical Escalations</b><br/>
        </div>

        <div className='sheldon-buttons'>
          <div>
            <span style={{ paddingRight: 10 }}>1.</span>
            <button
              className={
                type == 'cclocal/fetchsum'
                  ? 'pure-button pure-button__selected'
                  : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'cclocal/fetchsum')}
            >
              Fetch cclocal sum
            </button>
            This shows the sum of the transactions in cclocal
          </div>

          <div>
            <span style={{ paddingRight: 10 }}> (optional): </span>

            <button
              className={
                type == 'cclocal/fetchtransaction'
                  ? 'pure-button pure-button__selected'
                  : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'cclocal/fetchtransaction')}
            >
              Fetch cclocal transactions
            </button>
            This button will show each transaction stored in cclocal:
          </div>

          <div>
            <span style={{ paddingRight: 10 }}>2.</span>
            <button
              className={
                type == 'cclocal/backuptransaction'
                  ? 'pure-button pure-button__selected'
                  : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'cclocal/backuptransaction')}
            >
              Backup cclocal table
            </button>
            This backs up the transactions to a _bak table and clears cclocal
          </div>

          <div>
            <span style={{ paddingRight: 10 }}>3.</span>
            <button
              className={
                type == 'cclocal/fetchcclocalbaktablenames'
                  ? 'pure-button pure-button__selected'
                  : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'cclocal/fetchcclocalbaktablenames')}
            >
              Fetch cclocal_bak table name
            </button>
            This will grab the cclocal_bak table name to use the exact table name in the next steps
          </div>

          <div>
            <span style={{ paddingRight: 10 }}>4.</span>
            <input id="bakTableName1"  placeholder="Enter Table Name" onChange={(evt) => {bakTableName = (evt.target.value)}}/>
            <button
              className={
                type == 'cclocal/movetocclocal'
                  ? 'pure-button pure-button__selected'
                  : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'cclocal/movetocclocal')}
            >
              Move to cclocal
            </button>
            This moves the transactions from the _bak table back into cclocal to be processed
          </div>

          <div>
            <span style={{ paddingRight: 10 }}>5.</span>
            <input type="number" pattern="[0-9]*" id="stopdaysinput" required min="0" minLength={1} maxLength={3}
              onChange={(evt) => {maxStopDays = (evt.target.value)}}
              onInput={this.maxLengthCheck}
            />
            <button
              className={
                type == 'cclocal/updatemaxstopdays'
                  ? 'pure-button pure-button__selected'
                  : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'cclocal/updatemaxstopdays')}
            >
              Updates max stop days
            </button>
            This updates maxstopdays of payapi: max (999)
          </div>

          <div>
            <span style={{ paddingRight: 10 }}>6.</span>
            <button
              className={
                type == 'cclocal/uploadlocal'
                  ? 'pure-button pure-button__selected'
                  : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'cclocal/uploadlocal')}
            >
              Upload cclocal
            </button>
            This uploads cclocal transactions
          </div>

          <div>
            <span style={{ paddingRight: 10 }}>7.</span>
            <input id="bakTableName2"  placeholder="Enter Table Name" onChange={(evt) => {bakTableName = (evt.target.value)}}/>
            <button
              className={
                type == 'cclocal/dropbaktable'
                  ? 'pure-button pure-button__selected'
                  : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'cclocal/dropbaktable')}
            >
              Drop bak table
            </button>
            This removes the _bak table and all of it's data
          </div>

          <div>
            <span style={{ paddingRight: 10 }}>8.</span>
            <button
              className={
                type == 'cclocal/restmaxstopdaystodefault'
                  ? 'pure-button pure-button__selected'
                  : 'pure-button'
              }
              onClick={this.handleButtonClick.bind(this, 'cclocal/restmaxstopdaystodefault')}
            >
              Reset Max Stop Days
            </button>
            This resets Payapi max stop days back to 14
          </div>
        </div>

        <div className='sheldon-content sheldon-cmd'>
          <div style={{ height: panelHeight - 650, overflow: 'auto' }} ref='content'>
            {this.state.content}
          </div>
        </div>
      </div>
    );
  }
}

export default SheldonLinuxdashCmd;



// WEBPACK FOOTER //
// ./src/components/SheldonLinuxdashCmd.js